import { createContext, useContext, useState, useEffect } from "react";
import api, { getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauthenticated, object = admin

  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    api
      .get("/auth/me")
      .then((r) => {
        if (r.data?.role === "admin") setUser(r.data);
        else { setToken(null); setUser(false); }
      })
      .catch(() => setUser(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    if (data?.user?.role !== "admin") {
      setToken(null);
      const err = new Error("This account does not have admin access.");
      err.notAdmin = true;
      throw err;
    }
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setToken(null);
    setUser(false);
    window.location.assign("/login");
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
